import { BenefitDto } from '../../../models/dtos/benefit.dto';
import axios from '../../axios';

export default async function getBenefitsRequest(): Promise<BenefitDto[]> {
  const response = await axios.get<BenefitDto[]>(
    `${process.env.REACT_APP_BASE_URL}/users/benefit`
  );
  return response.data;
}
